import { date, number, object, SchemaOf, string } from 'yup'

import { currencies } from '../../models'
import { IsinFormValues, isinInstrumentTypes } from './models'

const instrumentTypes = Object.values(isinInstrumentTypes)

const isFrnOrFrtd = (type: string) => [isinInstrumentTypes.bond, isinInstrumentTypes.bond].includes(type)

const isBond = (type: string) => type === isinInstrumentTypes.bond

export const isinValidationSchema: SchemaOf<IsinFormValues> = object().shape({
  isin: string().required(),
  issuer: string()
    .trim()
    .matches(/^[A-Za-z\s-]+$/)
    .required(),
  type: string().oneOf(instrumentTypes).required(),
  maturity: date().required(),
  currency: string().oneOf(currencies).nullable(),
  frnIssueMargin: number().when('type', {
    is: isFrnOrFrtd,
    then: number().min(0),
    otherwise: number().notRequired(),
  }),
  frnBenchmark: string().when('type', {
    is: isFrnOrFrtd,
    then: string(),
    otherwise: string().notRequired(),
  }),
  coupon: number().when('type', {
    is: isBond,
    then: number().min(0).max(100),
    otherwise: number().nullable(),
  }),
})
